import { getRecords, byIds } from './baserow'

function flattenAuthorIds (authors) {
  return (authors || []).reduce((ids, group) => {
    return ids.concat(Array.isArray(group) ? group : [group])
  }, []).filter(author => author != null).map(author => {
    return typeof author === 'object' ? author.id : author
  }).filter(id => id != null)
}

export default {
  getAuthors () {
    return getRecords('Authors')
  },
  getAuthorsById (authorIdList) {
    const orderedIds = flattenAuthorIds(authorIdList)
    return getRecords('Authors', byIds(orderedIds)).then(response => ({
      data: { records: this.sortAuthorList(response.data.records, orderedIds) }
    }))
  },

  async getAuthorList (authors) {
    try {
      const response = await this.getAuthorsById(flattenAuthorIds(authors))
      return response.data.records
    } catch (err) {
      console.log(err)
      return []
    }
  },

  setupAuthor (response) {
    const author = {
      name: response.fields.name,
      institution: response.fields.institution,
      url: response.fields.url,
      id: response.id
    }
    return author
  },

  sortAuthorList (authorList, sorting) {
    const order = new Map(flattenAuthorIds(sorting).map((id, index) => [String(id), index]))
    return authorList.slice().sort((a, b) => {
      const aIndex = order.has(String(a.id)) ? order.get(String(a.id)) : Number.MAX_SAFE_INTEGER
      const bIndex = order.has(String(b.id)) ? order.get(String(b.id)) : Number.MAX_SAFE_INTEGER
      return aIndex - bIndex
    })
  }

}
